(() => {
  const storageKey = 'fluffstyle-color-mode';
  const root = document.documentElement;
  const systemPreference = window.matchMedia('(prefers-color-scheme: dark)');

  const storedMode = () => {
    try {
      const value = window.localStorage.getItem(storageKey);
      return value === 'dark' || value === 'light' ? value : null;
    } catch (_error) {
      return null;
    }
  };

  const updateControls = (mode) => {
    const darkModeActive = mode === 'dark';
    const actionLabel = darkModeActive ? 'Use light mode' : 'Use dark mode';

    document.querySelectorAll('[data-bird-theme-toggle]').forEach((button) => {
      button.setAttribute('aria-pressed', String(darkModeActive));
      button.setAttribute('aria-label', actionLabel);
      button.setAttribute('title', actionLabel);
      const label = button.querySelector('[data-bird-theme-toggle-label]');
      if (label) label.textContent = actionLabel;
    });
  };

  const applyMode = (mode, persist = false) => {
    root.dataset.colorMode = mode;
    root.style.colorScheme = mode;

    const themeColor = document.querySelector('meta[name="theme-color"]');
    if (themeColor) themeColor.content = mode === 'dark' ? '#101510' : '#ffffff';

    if (persist) {
      try {
        window.localStorage.setItem(storageKey, mode);
      } catch (_error) {
        // The selected mode still applies for this visit when storage is unavailable.
      }
    }

    updateControls(mode);
    document.dispatchEvent(new CustomEvent('bird:color-mode-change', { detail: { mode } }));
  };

  const hydrate = () => {
    const initialMode = root.dataset.colorMode === 'dark' ? 'dark' : 'light';
    applyMode(initialMode);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-bird-theme-toggle]');
    if (!button) return;
    applyMode(root.dataset.colorMode === 'dark' ? 'light' : 'dark', true);
  });

  document.addEventListener('shopify:section:load', hydrate);

  systemPreference.addEventListener('change', (event) => {
    if (!storedMode()) applyMode(event.matches ? 'dark' : 'light');
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrate, { once: true });
  } else {
    hydrate();
  }
})();
